var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.06 10.44a5.571 5.571 0 117.88-7.88 5.571 5.571 0 01-7.88 7.88zM6 3.429a.929.929 0 100 1.857.929.929 0 000-1.857zM6 6a.5.5 0 00-.5.5v3a.5.5 0 001 0v-3A.5.5 0 006 6z",
    fill: "#171719"
  })));
}
export default SvgInfo;